import { render, staticRenderFns } from "./formAcertoPromotorVendas.vue?vue&type=template&id=b6e0d676&"
import script from "./formAcertoPromotorVendas.vue?vue&type=script&lang=js&"
export * from "./formAcertoPromotorVendas.vue?vue&type=script&lang=js&"
import style0 from "./formAcertoPromotorVendas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDivider,VFlex,VForm,VLayout,VTextField})
